import React from "react";
import ReactDOM from "react-dom/client"; // Use the client module for React 18
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./i18n";

// Get the root element from the DOM
const container = document.getElementById("root");

// Create a root using createRoot
const root = ReactDOM.createRoot(container);

// Use root.render to render your app
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Keeping service worker registration as before
serviceWorker.unregister();
